import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import Cookies from 'js-cookie';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);


const CustomizedDialogs = React.forwardRef((props, ref) => {
  let guestsignup = Cookies.get('guestsignup');
  if(guestsignup && guestsignup.length>0){
    guestsignup = JSON.parse(guestsignup);
  }
  const [open, setOpen] = React.useState(false);

  const [otpNumber, setOtpNumber] = React.useState("");
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);

  const [otpVerifyLoading, setOtpVerifyLoading] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  var vertical='top',horizontal='center';

	function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {
		setOtpVerifyLoading(false);
	}, [open]);

  

  
  function callApi(){

		if(!otpNumber || otpNumber<100){
			setShowAlert(true);
			setAlertMessage("Enter otp number");			
			return false;	
		}
		
		if(otpNumber && otpNumber>100){			
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  

      
      
      setOtpVerifyLoading(true);

			const data = new FormData(); 
			data.append('otpNumber', otpNumber);
      data.append('token', guestsignup.token);
      data.append('studentName', guestsignup.studentName);
      
      if(guestsignup.email && guestsignup.email.length>0){
        data.append('email', guestsignup.email);
      }else{
        data.append('email', '');
      }

      if(props.dataObj.courseId && props.dataObj.courseId>0){
        data.append('courseId', props.dataObj.courseId);
      }
      ///data.append('templateId', props.dataObj.templateId);
      ///data.append('websiteId', props.dataObj.websiteId);
      data.append('device', 'web');
      if(props.dataObj.utmSource && props.dataObj.utmSource.length>0){ 
        data.append('source', props.dataObj.utmSource);
      }else{
        data.append('source', 'Guest Mock Test');
      }

			axios.post(API_URL+'/app/guest-verifyotp-signup', data, axiosHeader)
			.then((response) => {
        setOtpVerifyLoading(false);
				///document.writeln("RESPONSE RECEIVED: ", JSON.stringify(response)); 

				if(response && response.data && response.data.responseTxt==="success"){					
					///Cookies.set('guestsignup', JSON.stringify({'studentName':studentName,'otpNumber':otpNumber,'token':response.data.token}) ); 
					//document.writeln(JSON.stringify(response.data));
          if(response.data.obj && response.data.obj.studentId){
                      // Set cookie accountDetails to login on website
                      Cookies.set("accountDetails", JSON.stringify({
                        sid: response?.data?.obj?.studentId,
                        studentId: response?.data?.obj?.studentId,
                        loginId: response?.data?.obj?.loginId,
                        token: response?.data?.obj?.token,
                        studentName: response?.data?.obj?.studentName,
                        mobile: response?.data?.obj?.phoneNo,
                        email: response?.data?.obj?.emailId
                      }))
          
                      // Set cookie token for the use on website
                      Cookies.set("token", `"${response?.data?.obj?.token}"`)
          
                      localStorage.setItem("etlStudentObj", JSON.stringify(response.data.obj));
                      
                      if(response.data.obj.openedCourse!=null && response.data.obj.openedCourse>0){
                        localStorage.setItem("etlSelectCourse", response.data.obj.openedCourse);
                      }else{
                        localStorage.setItem("etlSelectCourse", 0);
                      }
                      
                      if(response.data.obj && response.data.obj.courses && response.data.obj.courses.length>0){
                        localStorage.setItem("etlMyCourses", JSON.stringify(response.data.obj.courses));
                      }else{
                        // in case courses are not available
                        props.reg(3);
                        handleClose();                        
                        return false;
                      }

              //submit test now ................        
              props.submitTest(response?.data?.obj?.loginId,response?.data?.obj?.token, props.dataObj.courseId, props.dataObj.templateId);        

          }
					return false;

        }else if(response && response.data && response.data.responseTxt==="invalid_otp"){
					setShowAlert(true);
					setAlertMessage("OTP is invalid.");			
					return false;  

				}else{					
					setShowAlert(true);
					setAlertMessage("Something wrong somewhere");			
					return false;

				}
			})
			.catch((error) => {
				//console.log("AXIOS ERROR: ", error);
			})
		}  
	}

  // function onEnter(event){
	// 	if(event.key === 'Enter'){
	// 		signup();
	// 	}
	// }
	function numberOnly(event){
		if (!/[0-9]/.test(event.key)) {
			event.preventDefault();
		} 
	}

  return (
    <>
      {/* <Button title={"Save "+testTypeLabel+" & Exit"} onClick={handleClickOpen} variant="contained" color="primary" >Save & Exit</Button> */}
      <Dialog fullWidth onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle onClose={handleClose}>
          {!window.navigator.onLine?<span style={{color:'#FF0000'}}>Alert</span>:<>Enter your OTP</>} 
        </DialogTitle>

        <DialogContent dividers>
            <div className="dialogSubmitTestBox">
              {!window.navigator.onLine?
              <p style={{color:'#FF0000',fontWeight:'bold',minHeight:60, padding: 20}}>
                It seems, you are not connected to the internet.
              </p>
              :
              <>
              <Box>
                <span style={{color:'#303f9f'}} >{(guestsignup && guestsignup.mobile)?<>OTP has been sent to your mobile: ******{guestsignup.mobile.substr(guestsignup.mobile.length - 4)}</>:null}</span>
                <TextField onChange={event => setOtpNumber(event.target.value)} onKeyPress={(event)=>{numberOnly(event)}} value={otpNumber} placeholder={'Enter your otp number'} sx={{fontSize: 10}} inputProps={{ maxLength: 6 }} fullWidth variant="outlined" />  
              </Box>

              <Box mt={2}>
              {otpVerifyLoading?
                <LoadingButton loading={otpVerifyLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#f96d02',color:'#FFFFFF'}}  variant="contained" >Wait...</LoadingButton>
                :<>
                <Button onClick={() => { callApi() }} variant="contained" style={{backgroundColor:'#008000',color:'#FFFFFF'}} >Verify OTP</Button>
                
                <a href='javascript:;' style={{textDecoration:'none'}} onClick={()=>{props.reg(1)}} >Change Mobile Number</a>

                </>
              }
              </Box>

                           
              {/* <Button onClick={() => { backToSelectTest() }} style={{marginRight:20}} size="small" variant="outlined" >Cancel Test</Button> */}
              </>
              }
            </div>
        </DialogContent>

        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

      </Dialog>
    </>
  );

});

export default CustomizedDialogs;
